import { Component, OnInit, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ExamTest } from '../models/exam-test';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { ComponentBase } from 'src/app/base-classes/componet-base';

@Component({
  selector: 'app-exam-scheduled-tests',
  templateUrl: './exam-scheduled-tests.component.html',
  styleUrls: ['./exam-scheduled-tests.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExamScheduledTestsComponent extends ComponentBase implements OnInit {

  constructor(private routingService: RoutingService) {
      super();
     }

  @Input() tests: ExamTest[]
  @Input() selectedStudentName: string;
  @Input() title: string;

  public dateMap = {};

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tests']) {
      if (this.tests) {
        this.dateMap = {};
        this.tests.forEach(test => {
          if (this.dateMap[test.examination_test_date]) {
            this.dateMap[test.examination_test_date].push(test);
          } else {
            this.dateMap[test.examination_test_date] = [];
            this.dateMap[test.examination_test_date].push(test);
          }
        });
      }
    }
  }

  takeExam(test: ExamTest){
    let route = new PrifactRoute();
    route.primary_command = ['start-online-exam', test.examination_test_id];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

}
